const CLARITY_PROJECT_ID = process.env.CLARITY_PROJECT_ID
const INTERNAL_EMAIL_DOMAIN = '@api4com.com'

let loaded = false

export function trackEvent (name) {
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') return
  window.clarity('event', name)
}

export function setTag (key, value) {
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') return
  window.clarity('set', key, value)
}

function isInternalEmail (email) {
  if (!email) return false
  return email.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN)
}

export function initClarity (email) {
  if (loaded) return
  if (isInternalEmail(email)) return
  if (!CLARITY_PROJECT_ID || CLARITY_PROJECT_ID === 'REPLACE_ME') {
    return
  }
  loaded = true
  ;(function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }
    t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i
    t.onload = function () { console.log('[clarity] tag loaded for project', i) }
    t.onerror = function () { console.error('[clarity] failed to load tag — likely blocked by ad-blocker or network') }
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y)
  })(window, document, 'clarity', 'script', CLARITY_PROJECT_ID)
}



// WEBPACK FOOTER //
// ./src/services/clarity.js